import {
  InstitutionUserDto,
  InvestigationResultSource,
  InvestigationTestResultDto
} from 'src/api/requests'

/**
 * A result is "external" when the backend marks its source as External, or when
 * it carries any of the external-only fields (source laboratory / sample
 * collection date). The fallback covers list/detail projections that populate
 * the lab fields but don't map the `source` enum.
 */
/** A result together with the approval state of the test it belongs to. The
 *  tests list flattens results onto specimen rows, and the approval state is
 *  what decides whether a result may still be edited. */
export type ResultWithApproval = {
  result: InvestigationTestResultDto
  isApproved?: boolean
  /** The referring doctor lives on the test/demand behind the result, not on
   *  the result itself. */
  referralDoctorUser?: InstitutionUserDto | null
  referralDoctorName?: string | null
  /** The investigation type classifier id, forwarded to EditTestResultModal so
   *  its result/value options are read from the same source AddResultModal
   *  uses instead of the unreliable standalone test-type endpoint. */
  typeId?: string
}

export const isExternalResult = (result: InvestigationTestResultDto) =>
  result.source === InvestigationResultSource.EXTERNAL ||
  !!result.sourceLaboratoryName ||
  !!result.sourceLaboratoryId ||
  !!result.sampleCollectedAt
